export default function ServiceArea() {
  const serviceAreas = [
    {
      name: 'Vashi',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Sanpada',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Nerul',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Koparkhairane',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Ghansoli',
      icon: 'ri-map-pin-line'
    },
    {
      name: 'Airoli',
      icon: 'ri-map-pin-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-amber-600 border border-amber-600 px-5 py-2 rounded-full inline-block mb-4">
            Service Coverage
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-5">Areas We Serve</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Free pickup and delivery across Navi Mumbai's prime locations
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {serviceAreas.map((area, index) => (
            <div
              key={index}
              className="group bg-amber-50 rounded-2xl p-6 text-center hover:bg-amber-600 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-amber-600 rounded-full mx-auto mb-4 group-hover:bg-white transition-colors">
                <i className={`${area.icon} text-white text-2xl group-hover:text-amber-600 transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-white transition-colors">
                {area.name}
              </h3>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-600 to-amber-700 rounded-3xl p-8 md:p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">
              Don't See Your Area?
            </h3>
            <p className="text-lg text-amber-50 mb-6">
              We're constantly expanding our service coverage. Contact us to check if we can serve your location!
            </p>
            <a
              href="tel:+918850056363"
              className="inline-flex items-center gap-2 bg-white text-amber-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-amber-50 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Call Us: +91 88500 56363
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
